// Code generated by pbe. DO NOT EDIT.
import { NewFields, ProtoMessage } from '../../runtime';
export var NullValue = /*#__PURE__*/function (NullValue) {
  NullValue[NullValue["NULL_VALUE"] = 0] = "NULL_VALUE";
  return NullValue;
}(NullValue || {});
export class BoolValue extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new BoolValue());
  }
}
BoolValue._fqn = 'values.BoolValue';
BoolValue._fields = NewFields([[1, {
  name: 'v',
  json: 'v',
  type: 8
}], [2, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class BytesValue extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new BytesValue());
  }
}
BytesValue._fqn = 'values.BytesValue';
BytesValue._fields = NewFields([[1, {
  name: 'v',
  json: 'v',
  type: 12
}], [2, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class DateRange extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new DateRange());
  }
}
DateRange._fqn = 'values.DateRange';
DateRange._fields = NewFields([[1, {
  name: 'from',
  json: 'from',
  type: 11,
  ctor: () => Timestamp
}], [2, {
  name: 'to',
  json: 'to',
  type: 11,
  ctor: () => Timestamp
}]]);
export class DoubleValue extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new DoubleValue());
  }
}
DoubleValue._fqn = 'values.DoubleValue';
DoubleValue._fields = NewFields([[1, {
  name: 'v',
  json: 'v',
  type: 1
}], [2, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class Empty extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Empty());
  }
}
Empty._fqn = 'values.Empty';
Empty._fields = NewFields();
export class FloatValue extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new FloatValue());
  }
}
FloatValue._fqn = 'values.FloatValue';
FloatValue._fields = NewFields([[1, {
  name: 'v',
  json: 'v',
  type: 2
}], [2, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class Go extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Go());
  }
}
Go._fqn = 'values.Go';
Go._fields = NewFields();
export class Int32Value extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Int32Value());
  }
}
Int32Value._fqn = 'values.Int32Value';
Int32Value._fields = NewFields([[1, {
  name: 'v',
  json: 'v',
  type: 5
}], [2, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class Int64Value extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Int64Value());
  }
}
Int64Value._fqn = 'values.Int64Value';
Int64Value._fields = NewFields([[1, {
  name: 'v',
  json: 'v',
  type: 3
}], [2, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class ListValue extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ListValue());
  }
}
ListValue._fqn = 'values.ListValue';
ListValue._fields = NewFields([[1, {
  name: 'values',
  json: 'values',
  type: 11,
  repeated: true,
  ctor: () => Value
}]]);
export class Remote extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Remote());
  }
}
Remote._fqn = 'values.Remote';
Remote._fields = NewFields([[1, {
  name: 'message',
  json: 'message',
  type: 9
}]]);
export class RemoteRef extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new RemoteRef());
  }
}
RemoteRef._fqn = 'values.RemoteRef';
RemoteRef._fields = NewFields([[1, {
  name: 'id',
  json: 'id',
  type: 12
}]]);
export class StringValue extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new StringValue());
  }
}
StringValue._fqn = 'values.StringValue';
StringValue._fields = NewFields([[1, {
  name: 'v',
  json: 'v',
  type: 9
}], [2, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class Struct extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Struct());
  }
}
Struct._fqn = 'values.Struct';
Struct._fields = NewFields([[1, {
  name: 'fields',
  json: 'fields',
  type: 11,
  map: true,
  ctor: () => [9, 11]
}]]);
export class Struct_FieldsEntry extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Struct_FieldsEntry());
  }
}
Struct_FieldsEntry._fqn = 'values.Struct.FieldsEntry';
Struct_FieldsEntry._fields = NewFields([[1, {
  name: 'key',
  json: 'key',
  type: 9
}], [2, {
  name: 'value',
  json: 'value',
  type: 11,
  ctor: () => Value
}]]);
export class Timestamp extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Timestamp());
  }
}
Timestamp._fqn = 'values.Timestamp';
Timestamp._fields = NewFields([[1, {
  name: 'seconds',
  json: 'seconds',
  type: 3
}], [2, {
  name: 'nanos',
  json: 'nanos',
  type: 5
}], [3, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class UInt32Value extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new UInt32Value());
  }
}
UInt32Value._fqn = 'values.UInt32Value';
UInt32Value._fields = NewFields([[1, {
  name: 'v',
  json: 'v',
  type: 13
}], [2, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class UInt64Value extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new UInt64Value());
  }
}
UInt64Value._fqn = 'values.UInt64Value';
UInt64Value._fields = NewFields([[1, {
  name: 'v',
  json: 'v',
  type: 4
}], [2, {
  name: 'isNull',
  json: 'is_null',
  type: 8
}]]);
export class Value extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Value());
  }
}
Value._fqn = 'values.Value';
Value._fields = NewFields([[1, {
  name: 'nullValue',
  json: 'null_value',
  type: 14
}], [2, {
  name: 'numberValue',
  json: 'number_value',
  type: 1
}], [3, {
  name: 'stringValue',
  json: 'string_value',
  type: 9
}], [4, {
  name: 'boolValue',
  json: 'bool_value',
  type: 8
}], [5, {
  name: 'structValue',
  json: 'struct_value',
  type: 11,
  ctor: () => Struct
}], [6, {
  name: 'listValue',
  json: 'list_value',
  type: 11,
  ctor: () => ListValue
}], [7, {
  name: 'integerValue',
  json: 'integer_value',
  type: 3
}]]);
